import React, { useState } from 'react';
import { FaUserAlt, FaRegIdCard, FaTimes } from 'react-icons/fa';
import { GiHouseKeys } from 'react-icons/gi';
import { MdMeetingRoom } from 'react-icons/md';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const BQ_BASE_URL = process.env.REACT_APP_BQ_BASE_URL;

const KeyHandover = ({ reservation, onClose, onHandoverKey }) => {
  const [loading, setLoading] = useState(false);

  if (!reservation) return null;

  const handleHandoverKey = async (bookingId) => {
    try {
      setLoading(true);

      // Sending API request for key handover
      const response = await fetch(`${BQ_BASE_URL}/bq/api/key-handover`, {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          bookingid: bookingId,
          paymentstatus: 'Paid',
        }),
      });

      const data = await response.json();

      if (response.ok) {
        toast.success('Key successfully handed over!', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        onHandoverKey(bookingId);
        setTimeout(() => onClose(), 3000); // Close modal after toast disappears
      } else {
        toast.error(data.detail || data.message || 'Failed to hand over key', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      toast.error('An error occurred. Please try again.', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center z-50">
        <div className="relative w-full max-w-lg p-8 bg-white rounded-lg shadow-xl">
          {/* Close button at top-right */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 focus:outline-none"
            aria-label="Close"
          >
            <FaTimes size={24} />
          </button>

          <div className="flex justify-center mb-4">
            <GiHouseKeys className="text-black" size={70} />
          </div>

          <h2 className="text-3xl font-semibold text-center text-gray-800 mb-3">Key Handover</h2>

          <p className="text-base font-medium text-center text-gray-600 mb-6">
            Verify the guest information, hand over the room key and update the status.
          </p>

          <div className="grid grid-cols-2 gap-2 mb-8 px-4">
            <div className="flex items-center text-gray-700">
              <FaUserAlt
                className="text-black mr-3 transform transition-transform duration-300 hover:scale-110"
                size={20}
              />
              <span className="font-medium text-gray-900">
                {reservation.firstname} {reservation.lastname}
              </span>
            </div>

            <div className="flex items-center text-gray-700">
              <MdMeetingRoom
                className="text-black mr-3 transform transition-transform duration-300 hover:scale-110"
                size={26}
              />
              <span className="font-medium text-gray-900">
                Room Type: {reservation.roomtypename}
              </span>
            </div>

            <div className="flex items-center text-gray-700">
              <GiHouseKeys
                className="text-black mr-1 transform transition-transform duration-300 hover:scale-110"
                size={28}
              />
              <span className="font-medium text-gray-900">Room No: {reservation.roomnumber}</span>
            </div>

            <div className="flex items-center text-gray-700">
              <FaRegIdCard
                className="text-black mr-4 transform transition-transform duration-300 hover:scale-110"
                size={26}
              />
              <span className="font-medium text-gray-900">
                Reservation number: {reservation.orderid}
              </span>
            </div>
          </div>

          <div className="flex justify-center">
            <button
              onClick={() => handleHandoverKey(reservation.bookingid)}
              className={`py-3 px-12 bg-black text-white font-semibold rounded-lg shadow-md ${
                loading ? 'cursor-not-allowed opacity-50' : 'hover:text-white'
              }`}
              disabled={loading}
            >
              {loading ? 'Processing...' : 'Hand Over Key'}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default KeyHandover;
